import { ComponentPropsWithoutRef, ElementType } from 'react';

import { cn } from '@components/primitives/utilities';

import { TextHeading } from './TextHeading';

import css from './styles.module.css';

export type TextProps<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  as?: T;
  weight?: number;
  color?: string;
  leading?: 'sm' | 'md' | 'lg';
  size?: 'sm' | 'md' | 'lg';
  truncate?: boolean;
  wrap?: 'wrap' | 'pretty' | 'balance';
};

export function Text<T extends ElementType = 'p'>({
  as,
  children,
  weight,
  color,
  size = 'md',
  leading,
  className,
  truncate,
  wrap,
  ...props
}: TextProps<T>) {
  const Component = as ?? 'p';

  return (
    <Component
      {...props}
      className={cn(css.text, className)}
      data-size={size}
      data-leading={leading}
      data-truncate={truncate}
      style={{
        '--weight': weight,
        '--color': color,
        '--wrap': wrap,
      }}
    >
      {children}
    </Component>
  );
}

Text.Heading = TextHeading;
